import { useState } from 'react';
import { EmployBookingList } from 'modules/booking';
import styles from './employBookingListTable.module.css';
import BookingsProcessPopup from '../bookinkPooup/BookingProcessPopup';
import CancelProcessPopup from '../bookinkPooup/CancelProcessPopup';


interface EmployBookingTableProps {
    bookings: EmployBookingList[];
    onSort: (key: 'parentName' | 'age' | 'request_date' | 'date' | 'status') => void;
    sortConfig: { key: keyof EmployBookingList | null; direction: 'asc' | 'desc' };
    onback: () => void;
    isCancel: boolean,
}

export default function EmployBookingListTable({ bookings, onSort, sortConfig, onback, isCancel }: EmployBookingTableProps) {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState<EmployBookingList | null>(null);

    const handleRowClick = (booking: EmployBookingList) => {
        setSelectedBooking(booking);
        setIsPopupOpen(true);
    };
    const handleClosePopup = () => {
        setIsPopupOpen(false);
        setSelectedBooking(null);
        onback();
        console.log(selectedBooking)

    };

    const sortedBookings = [...bookings].sort((a, b) => {
        if (sortConfig.key) {
            let aValue = a[sortConfig.key];
            let bValue = b[sortConfig.key];

            if (aValue === undefined) return 1;
            if (bValue === undefined) return -1;

            if (
                (sortConfig.key === 'request_date' || sortConfig.key === 'date') &&
                typeof aValue === 'string' &&
                typeof bValue === 'string'
            ) {
                const aDate = new Date(aValue.split('.').reverse().join('-'));
                const bDate = new Date(bValue.split('.').reverse().join('-'));

                return sortConfig.direction === 'asc' ? aDate.getTime() - bDate.getTime() : bDate.getTime() - aDate.getTime();
            } else {
                return sortConfig.direction === 'asc' ? (aValue < bValue ? -1 : 1) : (aValue > bValue ? -1 : 1);
            }
        }
        return 0;
    });

    return (
        <div className={styles.tbodyContainer}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th onClick={() => onSort('parentName')}>
                            Name {sortConfig.key === 'parentName' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                        </th>
                        <th onClick={() => onSort('age')}>
                            Alter {sortConfig.key === 'age' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                        </th>
                        <th onClick={() => onSort('request_date')}>
                            Anfrage am {sortConfig.key === 'request_date' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                        </th>
                        <th onClick={() => onSort('date')}>
                            Anfrage für {sortConfig.key === 'date' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                        </th>
                        <th className={styles.thStatus}
                            onClick={() => onSort('status')}>
                            Status {sortConfig.key === 'status' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {sortedBookings.map((booking, index) => (
                        <tr key={index} onClick={() => handleRowClick(booking)} className={styles.clickableRow}>
                            <td className={styles.tdNameCountainer}>{(
                                <div className={styles.tdNameCountainer}>
                                    <p className={styles.tdParentName}> {booking.parentName}</p>
                                    <p className={styles.tdKidName}> {booking.kidName}</p>
                                </div>
                            )}
                            </td>
                            <td>{booking.age} J.</td>
                            <td>{booking.request_date?.toString()}</td>
                            <td>{booking.date?.toString()}</td>
                            <td className={styles.tdStatus}>
                                <span className={`${styles.status} ${styles[booking.status.split('(')[0].trim()]}`}>
                                    <span className={styles.mainStatus}>
                                        {booking.status.split('(')[0].trim()}
                                    </span>

                                    {booking.status.includes('(') && (
                                        <span className={styles.subStatus}>
                                            {booking.status.split('(')[1].replace(')', '').trim()}
                                        </span>
                                    )}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>


            {selectedBooking && (
                !isCancel ? <BookingsProcessPopup
                    isOpen={isPopupOpen}
                    onClose={handleClosePopup}
                    bookinglist={selectedBooking}
                /> : <CancelProcessPopup
                    isOpen={isPopupOpen}
                    onClose={handleClosePopup}
                    bookinglist={selectedBooking}
                />
            )}
        </div>
    );
}
